import { styled } from '@mui/material';

export const CardContainer = styled('div')(({ theme }) => ({
  gap: theme.spacing(2),
  display: 'flex',
  '> div': {
    flex: 1
  }
}));
